import { render, staticRenderFns } from "./NFormConfirmation.vue?vue&type=template&id=b889393c&scoped=true&"
import script from "./NFormConfirmation.vue?vue&type=script&lang=js&"
export * from "./NFormConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b889393c",
  null
  
)

export default component.exports